/* ECO consent gate — global, delegated, resilient to AJAX/morph cart renders.
   Replaces the previous inline <script> in cart-summary.liquid, which did not
   execute when the cart section was morphed in (view-transition/AJAX nav) —
   leaving the checkbox inert and checkout permanently disabled. */
(function () {
  function applyConsent(ok) {
    document.querySelectorAll('[data-eco-consent-ctas]').forEach(function (ctas) {
      ctas.classList.toggle('is-consent-ok', ok);
      var btn = ctas.querySelector('#checkout, .cart__checkout-button');
      if (btn) btn.disabled = !ok;
    });
    document.querySelectorAll('.eco-consent__chk').forEach(function (c) {
      if (c.checked !== ok) c.checked = ok;
    });
  }

  function recordConsent(ok) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var value = ok ? ('Akzeptiert ' + new Date().toISOString()) : '';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Widerrufsverzicht': value } })
    }).catch(function () { /* keep optimistic UI state */ });
  }

  // Delegated on document → works no matter when/how the cart renders.
  document.addEventListener('change', function (e) {
    var chk = e.target && e.target.closest && e.target.closest('.eco-consent__chk');
    if (!chk) return;
    applyConsent(chk.checked);   // optimistic, instant
    recordConsent(chk.checked);
  });

  // Re-sync the UI from the (server-rendered) checkbox state after any cart re-render.
  function sync() {
    var chk = document.querySelector('.eco-consent__chk');
    if (chk) applyConsent(chk.checked);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('shopify:section:load', sync);
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, sync);
  });
})();
